export const TEST_ID = 'amsRecommendationSection';

export const AMS_DECIMAL_PRECISION = 2;
